"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = require("prop-types");

const useStateMachine = ({
  machine,
  delay = 500
}) => {
  const [state, setState] = (0, _react.useState)(machine.initial);
  /**
   * Update the current state
   * @param  e
   */

  const dispatchEvent = e => {
    setState(prev => machine.states[prev].on && machine.states[prev].on[e] || prev);
  };
  /**
   * Set next state, ready for change
   *
   */


  const setNext = () => {
    setTimeout(() => {
      const nextState = machine.states[state].next;
      if (nextState) setState(nextState);
    }, delay);
  };

  (0, _react.useEffect)(() => {
    if (!state) return;
    setNext(state);
  }, [state]);
  return [state, dispatchEvent];
};

useStateMachine.propTypes = {
  machine: (0, _propTypes.shape)({}).isRequired,
  delay: _propTypes.number
};
var _default = useStateMachine;
exports.default = _default;